/**
 * Legacy module retained for theme compatibility.
 * Ajax add-to-cart now keeps shoppers on the current page while the cart drawer
 * or the cart add confirmation presents the next action.
 */
export {};
